import { Box, Container, Grid, Typography } from '@material-ui/core';
import OnlineIcon from '@material-ui/icons/CheckCircle';
import OfflineIcon from '@material-ui/icons/ErrorRounded';
import React, { FC, useEffect, useState } from 'react';
import useSettings from 'src/hooks/useSettings';
import { api } from 'src/utils/api';
import NetworkHandler from './NetworkHandler';
import { useLongPress } from 'react-use';
import AccessMenu from 'src/components/AccessMenu';
import ResponsiveDialog from 'src/components/ResponsiveDialog';
import useSocket from 'src/hooks/useSocket';
import { disconnect } from 'src/slices/socket';
import { useDispatch } from 'src/store';
import { defaultOptionsForLongPress } from 'src/utils/common';
import useAuth from 'src/hooks/useAuth';

const TopBar: FC = () => {
  const { settings, saveSettings } = useSettings();
  const [isOffline, setIsOffline] = useState(settings?.statusIsOffline);
	const [openMenu, setOpenMenu] = useState(false);
	const dispatch = useDispatch();
	const {disconnectSocket, clearTunnelBoxData } = useSocket();
  const { logout } = useAuth();

  const handleOpen = () => {
		setOpenMenu(!openMenu);
	};
	const longPressEvent = useLongPress(handleOpen, defaultOptionsForLongPress);

	const handleDisconnect = () => {
		disconnectSocket();
		dispatch(disconnect());
    saveSettings({ tunnelId:null, tunnelName:null });
    clearTunnelBoxData();
    logout();
	};

	const handleThemeChange = () => {
		saveSettings({ 'theme': settings.theme === 'DARK' ? 'LIGHT' : 'DARK' });
	};

  useEffect(()=>{
    saveSettings({statusIsOffline: isOffline});
  }, [isOffline]);

  useEffect(() => {
  
    if(settings && settings.tunnelId){
    const interval = setInterval(async () => {
      const { status, data } = await api(`Status/TunnelQueue/${settings.tunnelId}`, 'get');
      if (status === 200 ) {
          setIsOffline(!data);
      } else {
        setIsOffline(true);
      }
    }, 30000);
  
    return () => {
      clearInterval(interval);
    };
   }
  }, []);
    
  return (
    <>
    <ResponsiveDialog
				title={'Menu'}
				showTitle={true}
				open={openMenu}
				onlyCloseBtn={true}
				children={
					<AccessMenu handleDisconnect={handleDisconnect} handleThemeChange={handleThemeChange} />
				}
				handleClose={() => {
					setOpenMenu(false);
				}}
			/>
    <NetworkHandler />
      <Container maxWidth={false}>
        <Grid container wrap="nowrap" justifyContent='space-between' style={{ marginTop: '10px' }} >
          <Grid item>
            <Box mt={5} mb={5}>
              <Typography variant="h3" color="textPrimary" gutterBottom>
                <Box {...longPressEvent} style={{ cursor: 'pointer' }}>
                  {settings?.tunnelName}
                </Box>
              </Typography>
            </Box>
          </Grid>
          <Grid item>
            <Box>
              {!isOffline ? 
                  <>
                      <OnlineIcon style={{ fontSize: '70', color: 'green' }} ></OnlineIcon>
                      <Typography color="textPrimary" style={{ marginLeft: '12px' }}>Online</Typography>
                  </>
                  :
                  <>
                      <OfflineIcon style={{ fontSize: '70', color: 'red' }} ></OfflineIcon>
                      <Typography  color="textPrimary" style={{ marginLeft: '12px' }}>Offline</Typography>
                  </>
              }
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default TopBar;
